import type { SVGProps } from "react";
import * as React from "react";
const SvgText = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M18.19 9.65c2.855 0 4.266 1.309 4.266 3.859v2.89c0 .56.204.697.544.697h.222V19c-.187.051-.664.12-1.037.12-.901 0-1.853-.307-2.091-1.514-.476.986-1.548 1.598-3.197 1.598-1.92 0-3.263-.918-3.263-2.499 0-1.615 1.07-2.43 3.06-2.839l2.838-.578c0-1.07-.476-1.632-1.343-1.632-.866 0-1.343.425-1.479 1.207l-2.924-.102c.357-2.108 1.921-3.11 4.403-3.11ZM14 19h-2.951L10 16H5l-.99 3H1L6 5h3l5 14Zm3.765-3.587c-.714.153-1.122.493-1.122 1.02 0 .544.34.867 1.02.867 1.087 0 1.87-.68 1.87-1.921v-.374l-1.768.408ZM5.863 13.637h3.353L7.5 8.5l-1.637 5.137Z"
    />
  </svg>
);
export default SvgText;
